<template>
  <div class="navbar">
    <a class="navbar-brand" href="/mypage">
      <img src="@/assets/image/logo.png" />
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({});
</script>

<style lang="scss">
.navbar {
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;

  .navbar-brand > img {
    width: auto;
    height: 25px;
  }

  img.icon-user {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border: 0;
    border-radius: 75px;
  }

  img.icon-cog {
    position: relative;
    top: -2px;
    width: 15px;
    height: 16px;
    margin-right: 10px;
  }

  img.icon-logout {
    position: relative;
    top: -2px;
    width: 15px;
    height: 14px;
    margin-right: 10px;
  }

  .dropdown-menu {
    min-width: 280px;
    font-size: 14px;
  }

  .dropdown-toggle em {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 16px;
  }

  .dropdown-toggle::after {
    display: none;
  }

  ul.dropdown-menu.dropdown-menu-right li a {
    padding: 15px 14px;
    border-bottom: 1px solid #f6f6f6;
  }
}
</style>
